import { forcePusherReconnect } from './connectionWatchdog';
import { restartApp } from './restartApp';

const SLEEP_GAP_MS = 2 * 60 * 1000;

let lastTickAt = Date.now();
let lastRecoverAt = 0;

/**
 * After PC sleep/wake: Pusher can look connected but dead.
 * Safe to call from tray focus and from keepalive when a long gap is detected.
 */
export function recoverAfterSleep() {
    const now = Date.now();
    if (now - lastRecoverAt < 5000) {
        return;
    }
    lastRecoverAt = now;
    console.warn('recoverAfterSleep: force pusher reconnect');
    forcePusherReconnect();
}

/**
 * Call from keepalive tick — large gap between ticks means the machine slept.
 * Chromium is unreliable after wake, so do a full process restart (fresh GPU/audio/net).
 */
export function keepaliveTickMaybeRecover() {
    const now = Date.now();
    const gap = now - lastTickAt;
    lastTickAt = now;
    if (gap >= SLEEP_GAP_MS) {
        console.warn(`keepalive gap detected (${Math.round(gap / 1000)}s) — restarting app`);
        restartApp();
    }
}
